import { useState } from "react";
import "../component/ForgetModel/index.css";
import Icons from "../../../components/icons";
import { useUsersContext } from "../../../context/usersContext";
import localforage from "localforage";
import { useResendVerifyEmail } from "../../../queries/auth";

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content-share text-center"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
const ResendEmailModal = ({ isModalOpen, justCloseIt, responseback, token }) => {
  const [processing, setProcessing] = useState(false);
  const resendEmailMutation = useResendVerifyEmail();
  const { agency: whitelabel } = useUsersContext();

  // prompt payload states
  const [email, setemail] = useState();

  // error status
  const [emailError, setemailError] = useState(null);

  const handleClose = () => {
    justCloseIt();
  };
  const handleAddUserSubmit = async () => {
    setProcessing(true);
    setemailError(null);
    const currentURL = window.location.href; // Get the full URL of the current page
    const urlObject = new URL(currentURL); // Create a URL object
    const domain = urlObject.hostname;

    if (!email) {
      setemailError("Email is required");
    }
    try {
      const response = await resendEmailMutation.mutateAsync({
        email: email,
        agency_id:
          whitelabel?._id || "6739f1be347a7f5974735cec",
        token
      });
      if (response) {
        handleClose();
        responseback(`Verification email send to the ${email}`);
      }
      setProcessing(false);
    } catch (error) {
      console.log("error", error);
      const respError = error?.response?.data;
      if (respError?.message === "User not found!") {
        setemailError(
          "We couldn't find an account with that email, please check for typos and try again"
        );
      } else if (respError?.message) setemailError(respError.message);
      else if (error?.response) {
        setemailError(error?.response?.data?.message);
      }
      setProcessing(false);
    }
  };

  return (
    <div>
      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content">
          <div style={{ position: "relative" }}>
            <p
              style={{
                position: "absolute",
                right: 0,
                width: "12px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            >
              X
            </p>

            <p className="modalText">Resend Verify Email</p>
            <div className="formGroup" style={{ marginBottom: "20px" }}>
              <label>Email</label>
              <input
                type="text"
                name="email"
                placeholder="Email"
                className="flex-1 modalInputs"
                value={email}
                onChange={(e) => {
                  setemail(e.target.value);
                  setemailError(null);
                }}
              />
              {emailError && (
                <small style={{ color: "hsl(var(--destructive))" }}>{emailError}</small>
              )}
            </div>

            <p
              className="disagreeBtn"
              style={{
                margin: 0,
                width: "100%",
                opacity: processing ? 0.6 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              disabled={processing}
              onClick={handleAddUserSubmit}
            >
              {processing && <Icons id="spinner" color="currentColor" />}
              Resend
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ResendEmailModal;
